module.exports = {
  messages: {
    UPSELL_LOGGED_OUT_PAGE_HEADER_HEADLINE: 'Find the right job for you',
    UPSELL_LOGGED_OUT_PAGE_HEADER_PREMIUM_PRODUCT_CTA: 'Discover Premium',
    UPSELL_LOGGED_OUT_PAGE_HEADER_PREMIUM_PRODUCT_HEADLINE:
      'Looking to grow your network?',
    UPSELL_LOGGED_OUT_PAGE_HEADER_PROJOBS_PRODUCT_CTA: 'Discover ProJobs',
    UPSELL_LOGGED_OUT_PAGE_HEADER_PROJOBS_PRODUCT_HEADLINE:
      'Looking for a new job?',
    UPSELL_LOGGED_OUT_PAGE_IMAGES_TEXT:
      '{number} million people already enjoy these benefits',
    UPSELL_LOGGED_OUT_PAGE_PREMIUM_PRODUCTS_CTA: 'Go Premium',
    UPSELL_LOGGED_OUT_PAGE_PRODUCTS_METATEXT_PREMIUM:
      'Includes all of the Premium benefits',
    UPSELL_LOGGED_OUT_PAGE_PRODUCTS_PREMIUM_BENEFIT_HEADER_1:
      'Personalise your business card',
    UPSELL_LOGGED_OUT_PAGE_PRODUCTS_PREMIUM_BENEFIT_HEADER_2:
      'Showcase your skills',
    UPSELL_LOGGED_OUT_PAGE_PRODUCTS_PREMIUM_BENEFIT_HEADER_3:
      'View profile visitors',
    UPSELL_LOGGED_OUT_PAGE_PRODUCTS_PREMIUM_BENEFIT_SUBHEADER_1:
      'Add up to 5 entries showing your experience',
    UPSELL_LOGGED_OUT_PAGE_PRODUCTS_PREMIUM_BENEFIT_SUBHEADER_2:
      'Give yourself the edge',
    UPSELL_LOGGED_OUT_PAGE_PRODUCTS_PREMIUM_BENEFIT_SUBHEADER_3:
      'Connect with people who take an interest in you',
    UPSELL_LOGGED_OUT_PAGE_PRODUCTS_PREMIUM_MAIN_HEADLINE: 'Premium',
    UPSELL_LOGGED_OUT_PAGE_PRODUCTS_PROJOBS_BENEFIT_HEADER_1:
      'Get found {number}x faster',
    UPSELL_LOGGED_OUT_PAGE_PRODUCTS_PROJOBS_BENEFIT_HEADER_2:
      'Get highlighted in recruiter search results',
    UPSELL_LOGGED_OUT_PAGE_PRODUCTS_PROJOBS_BENEFIT_HEADER_3:
      'Get every assistance',
    UPSELL_LOGGED_OUT_PAGE_PRODUCTS_PROJOBS_BENEFIT_SUBHEADER_1:
      'Boost your visibility among recruiters',
    UPSELL_LOGGED_OUT_PAGE_PRODUCTS_PROJOBS_BENEFIT_SUBHEADER_2:
      'Stand out from the crowd',
    UPSELL_LOGGED_OUT_PAGE_PRODUCTS_PROJOBS_BENEFIT_SUBHEADER_3:
      'Unlock the full range of job application support',
    UPSELL_LOGGED_OUT_PAGE_PRODUCTS_PROJOBS_MAIN_HEADLINE: 'ProJobs',
    UPSELL_LOGGED_OUT_PAGE_PRODUCTS_REGISTER_CTA: 'Register for free',
    UPSELL_LOGGED_OUT_PAGE_PRODUCTS_REGISTER_HEADLINE:
      'Not a XING member yet? ',
    UPSELL_LOGGED_OUT_PAGE_PRODUCTS_SUBHEADLINE_1:
      'Let your dream job find you',
    UPSELL_LOGGED_OUT_PAGE_PRODUCTS_SUBHEADLINE_2:
      'Land your next job through your network',
    UPSELL_LOGGED_OUT_PAGE_PROJOBS_PRODUCTS_CTA: 'Go ProJobs',
  },
};
